module.exports = __webpack_public_path__ + "static/media/TheIslandsofElsewhereBookJacket.618a2c55.jpg";